/* tslint:disable */
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { GridModule, RowFilterModule } from "@progress/kendo-angular-grid";
import { PopupModule } from "@progress/kendo-angular-popup";
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { NotificationsBarTileComponent } from "app/global/notifications.bar/notifications.bar.tile/notifications.bar.tile.component";
import {
	AutocompleteContentTemplateDirective
} from "common/ui/components/autocomplete/templates/autocomplete.content.template";
import {
	IconSelectionComponent
} from "../app.services/actions.config/components/icon-selection/icon.selection.component";
import { IconComponent } from "../app.services/actions.config/components/icon.display/icon.component";
import { PatientStatusComponent } from "../app.services/clinical/patient/components/patient.status.component";
import { StudyItemComponent } from "../app.services/clinical/patient/components/study.item/study.item.component";
import { AgePipe } from "../app.services/clinical/pipes/age.pipe";
import { PatientIdPipe } from "../app.services/clinical/pipes/id.pipe";
import { NamePipe } from "../app.services/clinical/pipes/name.pipe";
import { VisitSelectionComponent } from "../app.services/clinical/visit/components/visit.selection.component";
import { VisitSelectionItemComponent } from "../app.services/clinical/visit/components/visit.selection.item.component";
import { ExistsPipe } from "../dev/components/elad.forms2/pipes/exists.pipe";
import { FilterPipe } from "../dev/components/elad.forms2/pipes/filter.pipe";
import { FilterPurePipe } from "../dev/components/elad.forms2/pipes/filter.pure.pipe";
import { CardInputDirective } from "./cards/directives/card.input.directive";
import { DateTimeModule } from "./datetime/date.time.module";
import { ProgressbarComponent } from "./progressbar/progressbar.component";
import { CPTranslateModule } from "./translate";
import { ActionBarComponent } from "./ui/components/action.bar/action.bar.component";
import {
	ActionBarGroupComponent
} from "./ui/components/action.bar/components/action.bar.group/action.bar.group.component";
import { AutocompleteComponent } from "./ui/components/autocomplete/components/autocomplete.component";
import {
	AutocompleteExampleComponent
} from "./ui/components/autocomplete/components/example.autocomplete/autocomplete.example.component";
import { AutocompleteHeaderTemplateDirective } from "./ui/components/autocomplete/templates/autocomplete.header.template";
import { AutocompleteItemTemplateDirective } from "./ui/components/autocomplete/templates/autocomplete.item.template";
import {
	AutocompleteNoDataTemplateDirective
} from "./ui/components/autocomplete/templates/autocomplete.no.data.template";
import { BusyIndicatorComponent } from "./ui/components/busy.indicator/busy.indicator.component";
import { ButtonModule } from "./ui/components/button/button.module";
import { ButtonGroupComponent } from "./ui/components/buttongroup/button.group.component";
import { CheckboxModule } from "./ui/components/checkbox/checkbox.module";
import { EmptyStateComponent } from "./ui/components/empty-state/empty.state.component";
import { FavoriteButtonComponent } from "./ui/components/favorite-button/cp-favorite-button.component";
import {
	GridDropDownListFilterCellComponent
} from "./ui/components/grid/grid.filters/grid.dropdownlist.filter.cell.component/grid.dropdownlist.filter.cell.component";
import {
	GridInputFilterCellComponent
} from "./ui/components/grid/grid.filters/grid.input.filter.cell.component/grid.input.filter.cell.component";
import { GridNoRecordsComponent } from "./ui/components/grid/grid.no.records.component/grid.no.records.component";
import {
	HorizontalSelectionListComponent
} from "./ui/components/horizontal.selection.list/horizontal.selection.list.component";
import { IconButtonComponent } from "./ui/components/icon.button/component/icon.button.component";
import { IconTextRowComponent } from "./ui/components/icon.text.row/component/icon.text.row";
import { LayoutBoxComponent } from "./ui/components/layout.box/layout.box.component";
import { LayoutBoxesComponent } from "./ui/components/layout.boxes/layout.boxes.component";
import { SelectionListItemComponent } from "./ui/components/list.selection/list.selection.item/list.item.component";
import {
	ListSelectionWithSummaryComponent
} from "./ui/components/list.selection/list.selection.with.summary/list.selection.with.summary.components";
import { ListSelectComponent } from "./ui/components/list.selection/list.selection/list.select.component";
import { MultiSelectGridComponent } from "./ui/components/multiselect.grid/components/multiselect.grid.component";
import { CPPopUpModule } from "./ui/components/popup/popup.module";
import { SearchBoxComponent } from "./ui/components/search.box/search.box.component";
import {
	SelectableItemsComponent
} from "./ui/components/selectable.items.list/components/selectable.items.list.component";
import {
	SelectionBoxBarComponent
} from "./ui/components/selection.box/components/selection.box.bar/selection.box.bar/selection.box.bar.components";
import {
	SelectionBoxSearchComponent
} from "./ui/components/selection.box/components/selection.box.bar/selection.box.search/selection.box.search.component";
import {
	SelectionBoxContentComponent
} from "./ui/components/selection.box/components/selection.box.content/selection.box.content/selection.box.content.component";
import {
	SelectionDiagramComponent
} from "./ui/components/selection.box/components/selection.box.content/selection.diagram/selection.diagram.component";
import {
	SelectionListComponent
} from "./ui/components/selection.box/components/selection.box.content/selection.list/selection.list.component";
import {
	SelectionListItemTemplateDirective
} from "./ui/components/selection.box/components/selection.box.content/selection.list/selection.list.item.template";
import { SelectionBoxComponent } from "./ui/components/selection.box/components/selection.box/selection.box.component";
import { SeparatedListComponent } from "./ui/components/separated.list/separated.list.component";
import { SvgIconsModule } from "./ui/components/svg.icons/svg.icons.module";
import { TabComponent } from "./ui/components/tabs/tab.component/tab.component";
import { TabStripModule } from "./ui/components/tabs/tab.strip.module";
import { TabsWrapperComponent } from "./ui/components/tabs/tabs.wrapper.component/tabs.wrapper.component";
import { ToggleButtonWidgetComponent } from "./ui/components/toggle.button/toggle.button.component";
import { VerticalListSCrollbleModle } from "./ui/components/vertical.list.scrollable";
import { VerticalListComponent } from "./ui/components/vertical.list/vertical.list.component";
import { BorderExamStatusColorDirective } from "./ui/directives/border.exam.status.color/border.exam.status.color.directive";
import {
	BorderStatusIndicationDirective
} from "./ui/directives/border.status.indication/border.status.indication.directive";
import { ClickOutModule } from "./ui/directives/click.out/click.out.module";
import { AddClassToClosestParentDirective } from "./ui/directives/closest.parent/addClassToClosestParentDirective";
import { DblClickDirective } from "./ui/directives/dblclick/dblclick.directive";
import { DelayedHoverDirective } from "./ui/directives/delayed.hover/delayed.hover.directive";
import { DisableDirective } from "./ui/directives/disable/disable.directive";
import { FocusModule } from "./ui/directives/focus/focus.module";
import {
	HiddenExternalItemsNumDirective
} from "./ui/directives/hidden.external.items.num/hidden.external.items.num.directive";
import {
	HorizontalHiddenExternalConstWidthItemsNumDirective
} from "./ui/directives/hidden.external.items.num/horizontal.hidden.external.const.width.items.num.directive";
import { HorizontalHiddenItemsNumDirective } from "./ui/directives/hidden.external.items.num/horizontal.hidden.items.num.directive";
import { InputModeModule } from "./ui/directives/input.mode/input.mode.module";
import { MailToDirective } from "./ui/directives/mailto/cp.mailto.directive";
import { MaskedInputModule } from "./ui/directives/masked.input/masked.input.module";
import { CpVarDirective } from "./ui/directives/ng.var/cp.var.directive";
import { ScrollIntoViewDirective } from "./ui/directives/scroll.into.view/scroll.into.view.directive";
import { ScrollToDirective } from "./ui/directives/scroll.to/scroll.to.directive";
import { SelectContentDirective } from "./ui/directives/select.content/select.content.directive";
import { ShowOnDOMWhenActiveDirective } from "./ui/directives/show.on.dom.directive";
import { TitleTooltipDirective } from "./ui/directives/title.tooltip/title.tooltip.directive";
import { DraggingModule } from "./ui/directives/touch.drag/touch.module";
import { WidthOverflowModule } from "./ui/directives/width.overflow/width.overflow.module";
import { BreadCrumbPipe } from "./ui/pipes/breadcrumb.pipe";
import { MarkModule } from "./ui/pipes/mark.module";
import { SafePipe } from "./ui/pipes/safe.pipe";
import { AnyItemWithSpecifiedPropertiesValuesPipe } from "./utils/pipes/any.item.with.specified.properties.values.pipe";
import { AnyItemWithSpecifiedPropertyValPipe } from "./utils/pipes/any.item.with.specified.property.val.pipe";
import { BigItemsNumIndicationPipe } from "./utils/pipes/big.items.num.indication.pipe";
import { BoldTextPipe } from "./utils/pipes/bold.text.pipe";
import { CommonPipesModule } from "./utils/pipes/common.pipes/common.pipes.module";
import { FilterWithCountPipe } from "./utils/pipes/filter.with.count.pipe";
import { KeysPipe } from "./utils/pipes/keys.pipe";
import { MapToIterablePipe } from "./utils/pipes/object.to.array.pipe";
import { PluckPipe } from "./utils/pipes/pluck.pipe";
import { SkipPipe } from "./utils/pipes/skip.pipe";
import { SortPipe } from "./utils/pipes/sort.pipe";
import {
	ContextMenuDetectDirective,
	MouseMoveDetectDirective,
	MouseUpDetectDirective,
	WindowEventsDetector
} from "./window/window.event.detectors.component";

import {
	InlineNotificationComponent
} from "./ui/components/notification/inline.notification/inline.notification.component";

import { TableNamePipe } from "app.services/clinical/metadata/pipes/tableName.pipe";
import { PermissionsDirectiveTemplateDirective } from "app.services/permissions/directives/permission.directive.template";
import { ResourceAddressPipe } from "../app.services/patient.utils/pipes/resource.address.pipe";
import { PermissionsDirective } from "../app.services/permissions/directives/permissions.directive";
import { DbCasePipe } from "./utils/pipes/db.case.pipe";
import {DoubleLineDropdownItem} from "./ui/components/doubleLine.dropdown.item/double.line.dropdown.item.component";
import {CPTooltipModule} from "./ui/components/tooltip/tooltip.module";

let comps = [
	NotificationsBarTileComponent,
	IconComponent,
	ListSelectComponent,
	SelectionListItemComponent,
	SortPipe,
	SkipPipe,
	PluckPipe,
	SafePipe,
	ScrollToDirective, DblClickDirective,
	IconButtonComponent,
	SelectionBoxComponent, SelectionBoxBarComponent, SelectionBoxContentComponent, SelectionBoxSearchComponent,
	SelectionDiagramComponent, SelectionListComponent, SelectionListItemTemplateDirective,
	ToggleButtonWidgetComponent,
	ShowOnDOMWhenActiveDirective,
	ActionBarGroupComponent, ActionBarComponent, MapToIterablePipe, KeysPipe,
	SelectContentDirective,
	SelectableItemsComponent,
	SeparatedListComponent,
	AgePipe, NamePipe, PatientIdPipe,TableNamePipe,
	FilterPipe, ExistsPipe,FilterPurePipe,FilterWithCountPipe,AnyItemWithSpecifiedPropertyValPipe,AnyItemWithSpecifiedPropertiesValuesPipe,BigItemsNumIndicationPipe,
	WindowEventsDetector,
	MouseUpDetectDirective,
	MouseMoveDetectDirective,
	ContextMenuDetectDirective,
	PatientStatusComponent,
	TabComponent, TabsWrapperComponent,
	GridDropDownListFilterCellComponent, GridInputFilterCellComponent,
	GridNoRecordsComponent,
	AutocompleteComponent,
	AutocompleteExampleComponent,
	AutocompleteHeaderTemplateDirective,
	AutocompleteItemTemplateDirective,
	AutocompleteNoDataTemplateDirective,
	AutocompleteContentTemplateDirective,
	StudyItemComponent,
	HorizontalSelectionListComponent,
	VerticalListComponent,
	LayoutBoxComponent,LayoutBoxesComponent,
	CardInputDirective,
	AddClassToClosestParentDirective,
	ButtonGroupComponent,
	DisableDirective,
	CpVarDirective,
	TitleTooltipDirective,
	VisitSelectionComponent,
	VisitSelectionItemComponent,
	IconTextRowComponent,
	MailToDirective,
	BoldTextPipe,
	ScrollIntoViewDirective,
	IconSelectionComponent,
	ListSelectionWithSummaryComponent,
	BusyIndicatorComponent,
	BreadCrumbPipe,
	FavoriteButtonComponent,
	HiddenExternalItemsNumDirective,
	HorizontalHiddenExternalConstWidthItemsNumDirective,
	HorizontalHiddenItemsNumDirective,
	DelayedHoverDirective,
	MultiSelectGridComponent,
	BorderStatusIndicationDirective,
	ProgressbarComponent,
	BorderExamStatusColorDirective,
	PermissionsDirective,
	ResourceAddressPipe,
	DoubleLineDropdownItem,
	DbCasePipe
];
@NgModule({
	declarations: [
		comps
	],
	exports: [
		comps,
		VerticalListSCrollbleModle,
		CPPopUpModule,
		CPTranslateModule,
		DraggingModule,
		DateTimeModule,
		ClickOutModule,
		TreeViewModule,
		SvgIconsModule,
		InputModeModule,
		CheckboxModule,
		MarkModule,
		CommonPipesModule,
		WidthOverflowModule,
		FocusModule,
		InlineNotificationComponent,
		EmptyStateComponent,
		SearchBoxComponent,
		PermissionsDirectiveTemplateDirective
	],
	imports: [
		VerticalListSCrollbleModle,
		ClickOutModule,
		DateTimeModule,
		DraggingModule,
		CPTranslateModule,
		CommonModule,
		FormsModule,
		HttpClientModule,
		PopupModule,
		DropDownsModule,
		GridModule,
		RowFilterModule,
		CPPopUpModule,
		TreeViewModule,
		TabStripModule,
		ButtonModule,
		SvgIconsModule,
		InputModeModule,
		CheckboxModule,
		MarkModule,
		CommonPipesModule,
		WidthOverflowModule,
		MaskedInputModule,
		FocusModule,
		ProgressBarModule,
		CPTooltipModule,
		EmptyStateComponent,
		InlineNotificationComponent,
		SearchBoxComponent,
		PermissionsDirectiveTemplateDirective
	]
})
export class RISCommonModule {
}
